import {ImportVehiclesApiDto, ImportVehicleApiDto} from "../../api/model/rest";

export class ImportVehiclesResult {
	constructor(
		public readonly successCount: number,
		public readonly alreadyExistsCount: number,
		public readonly invalidRegistrationCount: number,
		public readonly vehicles: ImportVehicle[]
	) {}

	static fromJson(json: ImportVehiclesApiDto): ImportVehiclesResult {
		const vehicles = json.vehicles ? json.vehicles.map(v => ImportVehicle.fromJson(v)) : [];
		return new ImportVehiclesResult(
			json.successCount || 0,
			json.alreadyExistsCount || 0,
			json.invalidRegistrationCount || 0,
			vehicles
		);
	}

	get totalCount(): number {
		return this.successCount + this.alreadyExistsCount + this.invalidRegistrationCount;
	}

	get hasErrors(): boolean {
		return this.alreadyExistsCount > 0 || this.invalidRegistrationCount > 0;
	}
}

export class ImportVehicle {
	constructor(
		public readonly registration: string,
		public readonly status: 'SUCCESS' | 'INVALID_REGISTRATION' | 'ALREADY_EXISTS'
	) {}

	static fromJson(json: ImportVehicleApiDto): ImportVehicle {
		return new ImportVehicle(
			json.registration || '',
			json.status || 'SUCCESS'
		);
	}
}
